interface IconProps {
	fill?: string;
	stroke?: string;
}

export const HomeIcon: React.FC<IconProps> = ({
	fill = "#212B36",
	stroke = "#212B36",
}) => {
	return (
		<svg
			fill="none"
			height="21"
			viewBox="0 0 23 21"
			width="23"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M8.99724 12.5686H8.24724V13.3186V19.5686C8.24724 19.8419 8.02053 20.0686 7.74725 20.0686H3.99728C3.724 20.0686 3.49729 19.8419 3.49729 19.5686V10.8187V10.0687H2.74729H0.955765L11.1598 0.877678C11.1601 0.877458 11.1603 0.877237 11.1606 0.877018C11.3506 0.707659 11.6438 0.707661 11.8339 0.877023C11.8341 0.877241 11.8344 0.87746 11.8346 0.877678L22.0387 10.0687H20.2472H19.4972V10.8187V19.5686C19.4972 19.8419 19.2704 20.0686 18.9972 20.0686H15.2472C14.9739 20.0686 14.7472 19.8419 14.7472 19.5686V13.3186V12.5686H13.9972H8.99724Z"
				fill={fill}
				stroke={stroke}
				strokeWidth="1.5"
			/>
		</svg>
	);
};
